(() => {
  // Pickup-at-event only — no fulfillment option UI.
  // Line properties are set as hidden inputs on the product form.
  window.PITBFulfillment = { sync: () => Promise.resolve() };
})();
